import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { downloadFile } from 'apis/projects.api';
import { downloadPdfFile } from 'apis/projectProposals.api';
import { toast } from 'layout';
import { TOAST } from 'constant';
import { formatFileName, downloadOrViewPdfFile } from 'utils/func';
import { downloadPdfFinancialAdjustment } from 'apis/financialAdjustment.api';
import DownloadOrViewPdf from 'components/DownloadOrViewPdf';
import { downloadPersonnelAdjustmentPdfFile } from 'apis/personnelAdjustment.api';
import { DOWNLOAD_PDF_FILE } from 'apis/extendImplemetationTime.api';

export default function ManagementAppendix({ projectProposalId, project, attachment, isReview }) {
  const { t } = useTranslation();

  const { mutateAsync: mutateAsyncDownloadContractFile } = useMutation(downloadFile);

  const { mutateAsync: mutateAsyncDownloadRenewFile } = useMutation(DOWNLOAD_PDF_FILE);

  const { mutateAsync: mutateAsyncDownloadFinancialAdjustmentFile } = useMutation(
    downloadPdfFinancialAdjustment
  );

  const { mutateAsync: mutateAsyncDownloadExplanationFile } = useMutation(downloadPdfFile);

  const fileUrl = useMemo(() => project?.fileUrl ?? null, [project]);

  const extendImplementationTimes = useMemo(
    () => attachment?.extendImplementationTimes ?? [],
    [attachment]
  );

  const financialAdjustments = useMemo(() => attachment?.financialAdjustments ?? [], [attachment]);

  const personnelAdjustments = useMemo(() => attachment?.personnelAdjustments ?? [], [attachment]);

  const handleDownloadExplanationFile = async (opts, fileNameFormat, isView) => {
    try {
      const res = await mutateAsyncDownloadExplanationFile(opts.id);
      if (res?.data) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const filename =
          res.headers['content-disposition']?.split('filename=')?.[1] || fileNameFormat;
        downloadOrViewPdfFile(file, filename, isView);
      }
    } catch (error) {
      if (isView) {
        toast(TOAST.ERROR, t('projectProposal.review.viewPdfErrorTitle'));
      } else {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      }
    }
  };

  const handleDownloadFinancialAdjustmentFile = async (opts, fileNameFormat, isView) => {
    try {
      const res = await mutateAsyncDownloadFinancialAdjustmentFile(opts.id);
      if (res?.data) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const filename =
          res.headers['content-disposition']?.split('filename=')?.[1] || fileNameFormat;
        downloadOrViewPdfFile(file, filename, isView);
      }
    } catch (error) {
      if (isView) {
        toast(TOAST.ERROR, t('projectProposal.review.viewPdfErrorTitle'));
      } else {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      }
    }
  };

  const handleDownloadContractFile = async (opts, fileNameFormat, isView = false) => {
    try {
      const res = await mutateAsyncDownloadContractFile({ projectId: opts.id, path: opts.fileUrl });
      if (res?.data) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const filename =
          res.headers['content-disposition']?.split('filename=')?.[1] || fileNameFormat;
        downloadOrViewPdfFile(file, filename, isView);
      }
    } catch (error) {
      if (isView) {
        toast(TOAST.ERROR, t('projectProposal.review.viewPdfErrorTitle'));
      } else {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      }
    }
  };

  const handleDownloadRenewFile = async (opts, fileNameFormat = '', isView = false) => {
    try {
      const res = await mutateAsyncDownloadRenewFile({ id: opts.id });
      if (res?.data) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const filename =
          res.headers['content-disposition']?.split('filename=')?.[1] || fileNameFormat;
        downloadOrViewPdfFile(file, filename, isView);
      }
    } catch (error) {
      if (isView) {
        toast(TOAST.ERROR, t('projectProposal.review.viewPdfErrorTitle'));
      } else {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      }
    }
  };

  const { mutateAsync: mutateAsyncDownloadHumanResourceFile } = useMutation(
    downloadPersonnelAdjustmentPdfFile
  );

  const handleDownloadHumanResourceFile = async (opts, fileNameFormat, isView) => {
    try {
      const res = await mutateAsyncDownloadHumanResourceFile(opts.id);
      if (res?.data) {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const filename =
          res.headers['content-disposition']?.split('filename=')?.[1] || fileNameFormat;
        downloadOrViewPdfFile(file, filename, isView);
      }
    } catch (error) {
      if (isView) {
        toast(TOAST.ERROR, t('projectProposal.review.viewPdfErrorTitle'));
      } else {
        toast(TOAST.ERROR, t('projectProposal.review.exportPdfErrorTitle'));
      }
    }
  };

  return (
    <div className="mt-4">
      {/* <h5 className="">Management Appendix</h5> */}
      {isReview ? (
        <h4 className="mb-0">{t('submitDocument.summaryAndAppendix.explanationFile')}</h4>
      ) : (
        <h5 className="mb-0">{t('submitDocument.summaryAndAppendix.explanationFile')}</h5>
      )}

      {/* file thuyet minh de tai */}
      <DownloadOrViewPdf
        opts={{ id: projectProposalId }}
        fileName="Thuyet minh de tai"
        handleDownloadOrView={handleDownloadExplanationFile}
      />
      {isReview ? (
        <h4 className="mb-0">{t('submitDocument.summaryAndAppendix.contractFile')}</h4>
      ) : (
        <h5 className="mb-0">{t('submitDocument.summaryAndAppendix.contractFile')}</h5>
      )}
      {/* file hop dong */}
      {fileUrl && (
        <DownloadOrViewPdf
          opts={{ id: project?.id, fileUrl }}
          fileName={formatFileName(typeof fileUrl === 'string' ? fileUrl : fileUrl?.name)}
          handleDownloadOrView={handleDownloadContractFile}
        />
      )}
      {extendImplementationTimes?.length > 0 && (
        <>
          {isReview ? (
            <h4 className="mb-0">{t('submitDocument.summaryAndAppendix.renewalDocumentsFile')}</h4>
          ) : (
            <h5 className="mb-0">{t('submitDocument.summaryAndAppendix.renewalDocumentsFile')}</h5>
          )}
          {extendImplementationTimes.map((item) => (
            <div key={item?.id}>
              <DownloadOrViewPdf
                opts={{ id: item.id }}
                fileName={formatFileName(
                  typeof item.fileUrl === 'string' ? item.fileUrl : item.fileUrl?.name
                )}
                handleDownloadOrView={handleDownloadRenewFile}
              />
            </div>
          ))}
        </>
      )}

      {personnelAdjustments?.length > 0 && (
        <>
          {isReview ? (
            <h4 className="mb-0">
              {t('submitDocument.summaryAndAppendix.humanResourcesUpdateFile')}
            </h4>
          ) : (
            <h5 className="mb-0">
              {t('submitDocument.summaryAndAppendix.humanResourcesUpdateFile')}
            </h5>
          )}
          {personnelAdjustments.map((item) => (
            <div key={item.id}>
              <DownloadOrViewPdf
                opts={{ id: item.id }}
                fileName="Dieu chinh nhan su"
                handleDownloadOrView={handleDownloadHumanResourceFile}
              />
            </div>
          ))}
        </>
      )}

      {financialAdjustments?.length > 0 && (
        <>
          {isReview ? (
            <h4 className="mb-0">
              {t('submitDocument.summaryAndAppendix.adjustmentExpenditureFile')}
            </h4>
          ) : (
            <h5 className="mb-0">
              {t('submitDocument.summaryAndAppendix.adjustmentExpenditureFile')}
            </h5>
          )}
          {financialAdjustments.map((item) => (
            <div key={item.id}>
              <DownloadOrViewPdf
                opts={{ id: item.id }}
                fileName="Dieu chinh kinh phi"
                handleDownloadOrView={handleDownloadFinancialAdjustmentFile}
              />
            </div>
          ))}
        </>
      )}
    </div>
  );
}

ManagementAppendix.propTypes = {
  projectProposalId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  project: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  attachment: PropTypes.array.isRequired,
  isReview: PropTypes.bool,
};

ManagementAppendix.defaultProps = {
  isReview: false,
};
